import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { from } from 'rxjs';

export const MsalCustomGuard: CanActivateFn = (route, state) => {
  const msalGuard = inject(MsalGuard);
  return from(msalGuard.canActivate(route, state)); // Convert to Observable
};
